import { ReducerFnInterface } from '@context/type';
import { FeatureFlagStateInterface } from './featureFlag.type';

export const featureFlagReducer: ReducerFnInterface<
  FeatureFlagStateInterface
> = (state, { type, payload }) => {
  switch (type) {
    case 'featureFlag_update': {
      const featuresTemp = state.data;

      if (!featuresTemp.length) {
        featuresTemp.push(payload);
        return {
          data: featuresTemp,
        };
      }

      const indexFeature = featuresTemp.findIndex(
        (featureState) => featureState.feature === payload.feature,
      );

      if (indexFeature >= 0) {
        featuresTemp[indexFeature] = payload;
      }

      return {
        data: featuresTemp,
      };
    }

    default:
      return state;
  }
};

featureFlagReducer.key = 'featureFlag';
featureFlagReducer.initialState = {
  data: [],
};
